import { ActionTree, GetterTree, Module, MutationTree } from "vuex"
import { RootState } from "@/store/index"
import axios, { AxiosResponse } from "axios"

export type Currency = {
    name: string
    code: string
    symbol: string
}

export type CurrenciesState = {
    currencies: Currency[]
    loading: boolean
}

const state: CurrenciesState = {
    currencies: [],
    loading: false,
}

type CurrenciesApiResponse = {
    currencies: Currency[]
}

export const CurrenciesActions = {
    FETCH_CURRENCIES: "currencies/fetchCurrencies",
} as const

const mutations: MutationTree<CurrenciesState> = {
    setCurrencies(state, currencies: Currency[]) {
        state.currencies = currencies
    },
    setLoading(state, loading) {
        state.loading = loading
    },
}

const actions: ActionTree<CurrenciesState, RootState> = {
    async fetchCurrencies({ commit }) {
        commit("setLoading", true)

        try {
            const res = await axios.get<AxiosResponse<CurrenciesApiResponse>>("/currencies")
            commit("setCurrencies", res.data.data.currencies)
        } catch (e) {
            console.error("Error while fetching currencies", e)
        } finally {
            commit("setLoading", false)
        }
    },
}

const getters: GetterTree<CurrenciesState, RootState> = {
    currencies: ({ currencies }) => currencies,
    loading: ({ loading }) => loading,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
} as Module<CurrenciesState, RootState>
